module.exports = __webpack_public_path__ + "img/16.cad73f2e.jpg";